import axios from 'axios';
import {
  Message,
  MessageBox,
} from 'element-ui';
import Cookie from 'js-cookie';

import router from '../router';

// 创建axios实例
let service;
if (process.env.NODE_ENV == 'development') {
  service = axios.create({
    baseURL: 'https://api.prosuntech.com',
    // baseURL: 'http://t-api.prosuntech.com',
    // baseURL: 'http://192.168.0.114:9002',

    // timeout: 5000 // 请求超时时间
  })
} else {
  service = axios.create({
    baseURL: 'https://api.prosuntech.com',
    // baseURL: 'http://t-api.prosuntech.com',
    // timeout: 5000 // 请求超时时间
  })
}


// request拦截器
service.interceptors.request.use(config => {
  if (window.sessionStorage.getItem('token') && window.sessionStorage.getItem('token').length > 30) {
    config.headers['Authorization'] = "Bearer" + " " + window.sessionStorage.getItem('token')
    // config.headers['Authorization'] = Cookie.get('token')
  } // 让每个请求携带自定义token 请根据实际情况自行修改
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})
var timeoutflag = null

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非20000是抛错 可结合自己业务进行修改
    */
    const res = response
    // console.log(res)
    if (res.status !== 200 && res.status !== 204) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      if (res.status == 401 || res.status == 403) {
        Message({
          message: "权限异常或者无权限,请联系管理员",
          type: 'error',
          duration: 5 * 1000
        })
        return response
      }
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      //     confirmButtonText: '重新登录',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('FedLogOut').then(() => {
      //       location.reload() // 为了重新实例化vue-router对象 避免bug
      //     })
      //   })
      // }
      return Promise.reject('error')
    } else {
      return response

    }
  },
  error => {
    let message = error.message
    if (error.response.status === 404) {
      message = '接口访问失败'
    } else if (error.response.status === 403 || error.response.status === 401) {
      MessageBox.alert("<p style='margin:-25px 0 0 0 ;line-height:16px'><i class='el-icon-info' style='color:#3bc492;margin-right:5px;font-size:16px;line-height:16px'></i>提示</p><p style='margin-left:20px;padding-top:15px'>令牌失效，请重新登录。</p>", {
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: false,
        beforeClose: (action, instance, done) => {
          if (action == 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            Cookie.remove('token', { path: '/', domain: '192.168.18.134' });
            Cookie.remove("token", { path: "/", domain: ".prosuntech.com" });
            Cookie.remove('token', { path: '/', domain: '.joyousoa.com' });
            window.sessionStorage.removeItem('token');
            router.replace('/login');
            window.location.reload();
            setTimeout(() => {
              done();
              instance.confirmButtonLoading = false;
            }, 100);

          } else {
            done();
          }
        }
      });
      message = '您无访问权限,请联系管理员'
    }

    if (timeoutflag != null) {
      clearTimeout(timeoutflag);
    }

    // timeoutflag = setTimeout(function () {
    //   Message({
    //     showClose: true,
    //     message,
    //     type: 'error',
    //   })
    // }, 500);
    // if (error.response.status === 403) {
    //   console.log('403-------')
    //   window.sessionStorage.removeItem('token')
    //   // this.$router.replace('/login')
    //   window.location.reload()
    // }
    return Promise.reject(error)
  }
)

export default service
